var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDinner = function SvgDinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.703 19.21v-1.208c0-3.338-2.747-6.044-6.085-6.044s-6.084 2.706-6.084 6.044v1.209M2.325 19.21h19.422M21.747 11.958a2.418 2.418 0 0 1-4.836 0V8.332h4.836zM19.33 19.21v-4.834M9.618 10.75v1.208M7.2 9.54c0-.668.541-1.209 1.209-1.209h4.876a1.209 1.209 0 1 0 0-2.417h-2.458a1.21 1.21 0 0 1-1.21-1.21V3.497"
  })));
};
export default SvgDinner;